import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { stringifyInputs } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function ClaimCountsByDiseaseForm({ location, inPlaintiff }) {
  console.log('ClaimCountsByDiseaseForm rendered: ', location)

  const init = {
    plaintiffStatus: '',
    plaintiffCounsel: ''
  }

  const navigate = useNavigate()
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('ClaimCountsByDiseaseForm.submitSearch', inputs)
    let reportType = inPlaintiff ? 'P' : 'D'
    inputs.reportType = inPlaintiff ? 'PLAINTIFF' : 'DEFENSE'
    let queryString = `/custom/claim_count_by_report?inputs=${stringifyInputs(inputs)}&reportType=${reportType}`
    navigate(queryString)
  }

  function uniqueOptionCallback(data) {
    const dataCopy = JSON.parse(JSON.stringify(data))
    dataCopy.unshift({ id: '-1', name: 'All Unclosed' })
    return dataCopy
  }

  let plaintiffCounsel = ''
  if (inPlaintiff) {
    plaintiffCounsel = <CustomSelectListInput label="Plaintiff Counsel" className="custom-input" handleChange={handleInputChange} modelName="Asbestos" entityName="opposing_firm" name='plaintiffCounsel' />
  }


  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText="Summary of Claims by Current Diagnosis" />
            <tbody>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' uniqueOptionCallback={uniqueOptionCallback} />
              {plaintiffCounsel}
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

